import React, { lazy } from 'react'
import { DashSwitch } from '@retailer-platform/dashboard/routing'
import { ChakraProvider } from '@chakra-ui/react'
import { DomainRoute } from '../utils/domain/routingComponents'
import { massopsAccessControl } from '../access-control/massopsAccess.configuration'

const MassopsInterventionsPage = lazy(
  () => import('../pages/interventions/MassopsInterventionsPage')
)
const MassopsInterventionPage = lazy(() => import('../pages/intervention/MassopsInterventionPage'))
const MassopsCreateInterventionPage = lazy(
  () => import('../pages/create-intervention/MassopsCreateInterventionPage')
)
const MassopsApproveInterventionPage = lazy(
  () => import('../pages/approve-intervention/MassopsApproveInterventionPage')
)
const MassopsUploadInterventionDataPage = lazy(
  () => import('../pages/upload-intervention-data/MassopsUploadInterventionDataPage')
)
const MassopsInterventionSettingsPage = lazy(
  () => import('../pages/intervention-settings/MassopsInterventionSettingsPage')
)
// @hygen:inject page-import

// Note that this is intentionally not a component. Do not wrap <DomainRoute> with anything else, as it will cause issues with the parent <Switch />
// More information here https://v5.reactrouter.com/web/api/Switch/children-node
export const massopsRouter = (
  <ChakraProvider>
    <DomainRoute route="massops">
      <DashSwitch>
        <DomainRoute exact route="massops-interventions" component={MassopsInterventionsPage} />
        <DomainRoute
          exact
          route="massops-intervention"
          component={MassopsInterventionPage as React.ComponentType<any>}
        />
        <DomainRoute
          exact
          route="massops-create-intervention"
          component={MassopsCreateInterventionPage as React.ComponentType<any>}
        />
        <DomainRoute
          exact
          route="massops-approve-intervention"
          component={MassopsApproveInterventionPage as React.ComponentType<any>}
        />
        <DomainRoute
          exact
          route="massops-upload-intervention-data"
          component={MassopsUploadInterventionDataPage as React.ComponentType<any>}
        />
        <DomainRoute
          exact
          route="massops-intervention-settings"
          component={MassopsInterventionSettingsPage as React.ComponentType<any>}
        />
        {/* @hygen:inject router-route 
        injection point for routes, please do not delete */}
      </DashSwitch>
    </DomainRoute>
  </ChakraProvider>
)
